import { useNavigate } from 'react-router';

import { Button } from '../Button';
import { Heading } from '../Heading';
import { Link } from '../Link';
import { Para } from '../Para';
import { Stack } from '../Stack';

type Props = {
  error: Error | null;
  resetError: () => void;
};

export function FatalErrorWithStack({ error, resetError }: Props) {
  const navigate = useNavigate();

  const handleClick = () => {
    resetError();
    navigate('/', { replace: true });
  };

  return (
    <Stack gap={6}>
      <Heading variant="h2" align="left">
        Interner Server Fehler!
      </Heading>

      <Para>
        Ooops, irgendetwas ist schief gelaufen. Versuche es doch gerne nochmal oder schreib uns
        gerne an{' '}
        <Link href="mailto:hey@drycut.ch" rel="nofollow noopener noreferrer">
          hey@drycut.ch
        </Link>
        .
      </Para>

      <Para as="span" className="text-mono text-gray-500 bg-yellow-50 p-2 leading-5" size="xs">
        <pre>{error?.stack}</pre>
      </Para>

      <Stack className="items-start">
        <Button onClick={handleClick}>Zur Startseite</Button>
      </Stack>
    </Stack>
  );
}
